<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span> <em name="Exhibition"></em>
            <span>/</span>Phone Application
          </div>
          <div>
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <div class="MbDevice">
        <div class="homeLeft mt-5">
          <div class="UserAccount ml-1">
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ eExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>

      <div class="articleEn">
        <div>
          <div class="PcDevice">
            <div class="contentBoxStatus py-3">
              <div class="d-flex align-items-center justify-content-around">
                <div
                  v-for="(item, index) in MenuInvitation"
                  :key="index"
                  class="btn btn-white py-2 px-4"
                  style="border-radius: 20px; border-color: #d9d9d9"
                  @click="InviteLink(item.Url)"
                >
                  <span
                    class="font-weight-bold text-primary"
                    style="font-size: 16px"
                    v-if="item.MenuName == 'Phone Application'"
                  >
                    <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                  </span>
                  <span v-else> <i class="fas fa-caret-right"></i> {{ item.MenuName }} </span>
                </div>
              </div>
            </div>
            <div class="my-3"></div>
          </div>
          <div class="contentBox">
            <!-- left -->
            <div class="proLeft NoShowInMobile align_c">
              <img src="@/assets/images/iconTel.svg" width="100%" />
            </div>
            <!-- left end -->
            <!-- right -->
            <div class="proRight">
              <div class="MbDevice">
                <!-- <h1> <img src="../images/iconTel.svg" width="35px" class="mb-1"> Phone Application</h1> -->

                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <!-- <h1><img src="@/assets/images/iconInvite.svg" width="35px" class="mb-2" /> Phone Application</h1> -->

                    <div class="d-flex align-items-center">
                      <div>
                        <img src="@/assets/images/iconTel.svg" width="35px" class="mt-1 mr-1" />
                      </div>
                      <div>
                        <h1>Phone Application</h1>
                      </div>
                    </div>
                  </div>
                  <div class="mb-2">
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        <span class="border py-1 px-3">
                          <i class="fas fa-ellipsis-h"></i>
                        </span>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, index) in MenuInvitation" :key="index">
                          <span class="MbListGray" @click="InviteLink(item.Url)"> {{ item.MenuName }} </span>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              <div class="PcDevice">
                <h1>Phone Application</h1>
              </div>
              <p class="my-3">&nbsp;</p>
              <p>
                You can provide phone application for your important clients. Please contact our sales and provide your
                clients list (name and mobile number). And remind your clients to the service counter during the
                exhibition period and obtain admission.
              </p>
              <p class="my-3">&nbsp;</p>
              <ol class="number">
                <li>
                  Exhibitors who need this service, can contact our sales to request the application form. Please
                  provide the form before <span class="red"><span name="CloseDay"></span> 12:00</span>.
                </li>
                <li>Client list contains names and phone numbers. Incomplete information will not be accepted.</li>
                <li>Please provide the clients list together to speed up the process.</li>
              </ol>
              <p class="my-5">&nbsp;</p>
              <h3 class="font-weight-bold">Contact</h3>
              <p class="my-3">&nbsp;</p>
              <div name="ExpoContact"></div>
            </div>
            <p class="clear"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: 'Phone Application - ExhibitorServiceTW',
      }
    },

    data() {
      return {
        UserId: '',
        RegNo: '',
        lang: 'en',
        MenuInvitation: [],
        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },
    methods: {
      InviteLink(Url) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`
        }
      },
    },

    created() {
      const vm = this

      //取得語系

      let lang = 'en'

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1]

      //取得邀請選單
      axios
        .get(`https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`)
        .then((response) => {
          // console.log(response.data.Data)

          vm.MenuInvitation = response.data.Data
        })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`).then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue
      })

      $.getJSON('/apiExhibitors/Exhibition/' + vm.RegNo, { lang: lang }, function (data) {
        //close day 展覽前一天23:59
        var CloseDay = new Date(data.Data.ExhBegin)
        CloseDay.setDate(CloseDay.getDate() - 1)
        $('[name="CloseDay"]').text(formatDate(CloseDay))
        function formatDate(date) {
          var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()
          if (month.length < 2) month = '0' + month
          if (day.length < 2) day = '0' + day
          return [year, month, day].join('/')
        }

        //contact info

        $.getJSON('/apiExhibitors/ExpoContact/' + vm.RegNo + '?lang=' + lang, function (data) {
          $('[name="ExpoContact"]').html(data.Data.ExpoContact)
        })
      })
    },
  }
</script>

<style lang="scss"></style>
